import { mediaUrl } from '@/lib/api';

export const DEFAULT_PORTRAIT =
  'https://media.thisiszacharygray.com/img/artwork/portrait.jpg';

export function resolvePortrait(path?: string): string {
  let value = (path || '').trim();
  if (!value || /\/img\/index\.(mp4|gif)(\?|$)/i.test(value)) {
    value = DEFAULT_PORTRAIT;
  }
  if (/^\/?img\/index\.jpe?g(\?|$)/i.test(value)) {
    value = DEFAULT_PORTRAIT;
  }
  if (value.startsWith('http://') || value.startsWith('https://')) return value;
  if (value.startsWith('blob:') || value.startsWith('data:')) return value;
  if (
    value.startsWith('img/artwork/') ||
    value.startsWith('/img/artwork/') ||
    /^img\/artwork\//i.test(value)
  ) {
    return mediaUrl(value.startsWith('/') ? value : `/${value}`);
  }
  if (value.startsWith('/')) return mediaUrl(value);
  return mediaUrl(value);
}

export function isVideoPortrait(path: string): boolean {
  return /\.(mp4|webm|mov)(\?|$)/i.test(path);
}
